import { useState } from "react";
import RenderTable from "../forms/admin/renderTable";
import RenderForms from "../forms/admin/renderForms";

const TABLES = ["Country", "Currency", "CompanyType", "RecognizedExchanges", "RegulatoryBodies", "SubscriptionPlan", "Tooltips"];
const DISPLAY_NAMES = {
  RecognizedExchanges: "Recognised Exchanges"
};
const TableAdministrationComponent = () => {
    const [currentTable, setCurrentTable] = useState(null);
    const [showForm, setShowForm] = useState(false);

    const handleTableChange = (table) => {
        setCurrentTable(table);
    }

    return (
        <>
            <div className="recent-requests">
                <div style={{ width: "100%", display: "flex", gap: "10px" }}>
                    <div className="comprefrence" style={{ width: "100%" }}>
                        <div className="dashboard-header">
                            <h4 className="welcomeText">Table Administration</h4>
                        </div>

                        <div className="table-admin_div">
                            {TABLES.map((value, index) => (
                            <button
                                key={index}
                                className={`add-request ${
                                    currentTable === value ? "active-table-button" : "inactive-table-button"
                                }`}
                                onClick={() => handleTableChange(value)}
                            >
                               {DISPLAY_NAMES[value] || value.replace(/([A-Z])/g, " $1").trim()}
                            </button>
                            ))}
                        </div>
                        {
                            currentTable && <>
                                <h4>
  {(DISPLAY_NAMES[currentTable] || currentTable.replace(/([A-Z])/g, " $1").trim())} Table
</h4>

                                {currentTable !== "Tooltips" && (
        <button className="add-request" onClick={() => setShowForm(!showForm)}>
          Add New
        </button>
      )}
                            </>
                        }
                        <RenderForms table={currentTable} show={showForm} onClose={()=>setShowForm(false)} />
                        <RenderTable table={currentTable} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default TableAdministrationComponent;